// extracted by mini-css-extract-plugin
export default {"tooltip":"gV-z","arrow":"hV-z"};